import type { VideoItem } from "@/types/video";

interface PlayerPlaceholderProps {
  video: VideoItem;
}

export default function PlayerPlaceholder({ video }: PlayerPlaceholderProps) {
  return (
    <section>
      <h2 className="mb-4 font-heading text-lg font-bold text-foreground-950">在线观看</h2>
      <div className="relative aspect-video w-full overflow-hidden rounded-lg border border-background-200 bg-secondary-950">
        <img
          src={video.backdrop}
          alt={`${video.title} 播放预览图`}
          title={`${video.title} 在线观看`}
          className="h-full w-full object-cover opacity-40"
        />
        <div className="absolute inset-0 flex flex-col items-center justify-center px-4 text-center">
          <span className="flex h-16 w-16 items-center justify-center rounded-full border border-background-50/40 bg-background-50/10 text-background-50">
            <i className="ri-play-fill text-3xl" />
          </span>
          <p className="mt-4 font-heading text-base font-semibold text-background-50">
            暂未接入在线播放，敬请期待
          </p>
          <p className="mt-2 max-w-md text-xs leading-relaxed text-background-300">
            本站当前仅提供影视内容浏览与信息展示，正式视频播放功能将后续开放，感谢你的理解与支持。
          </p>
        </div>
      </div>
    </section>
  );
}